/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import { Form, Input, Select, Checkbox } from 'antd';
import { useSelector } from 'react-redux';
import DokanSettingsFieldLabel from '../text/DokanSettingsFieldLabel';

const { Option } = Select;

// eslint-disable-next-line no-unused-vars
export default function StoreGeneral({store, onInputChange}) {

    return (
        <>
            <DokanSettingsFieldLabel>Store Name</DokanSettingsFieldLabel>
            <Form.Item>
                <Input value={store.store_name} />
            </Form.Item>
            <DokanSettingsFieldLabel>Address</DokanSettingsFieldLabel>
            <Form.Item>
                <Input placeholder="street" value={store.address?.street_1}/>
            </Form.Item>

            <Form.Item>
                <Input placeholder="street 2" value={store.address?.street_2}/>
            </Form.Item>
            <div className="flex flex-col md:flex-row md:flex-grow-6 md:gap-3">
                <div className="md:flex-grow-3">
                    <Form.Item>
                    <Input placeholder="City" value={store.address?.city}/>
                    </Form.Item>
                </div>
                <div className="md:flex-grow-3">
                <Form.Item>
                    <Input placeholder="Post/Zip Code" value={store.address?.zip} />
                </Form.Item>
                </div>
            </div>
            <Form.Item>
                <Select
                    value=""
                    defaultValue="IND"
                    size="large"
                    className="mt-5 text-matt-black"
                    style={{ width: '100%' }}
                    onChange={() => {}}
                >
                    <Option value="BD">Bangladesh</Option>
                    <Option value="IND">INDIA</Option>
                    <Option value="PAK">Pakistan</Option>
                </Select>
            </Form.Item>
            <Form.Item>
                <Select
                    defaultValue="dhk"
                    size="large"
                    className="text-matt-black"
                    style={{ width: '100%' }}
                    onChange={() => {}}
                >
                    <Option value="dhk">Dhaka</Option>
                    <Option value="del">Delhi</Option>
                    <Option value="karchi">Karachi</Option>
                </Select>
            </Form.Item>
            <Form.Item>
                <Input placeholder="Phone No" value={store.phone} />
            </Form.Item>

            <DokanSettingsFieldLabel>Email</DokanSettingsFieldLabel>
            <Form.Item>
                <Checkbox><span className="font-normal text-matt-black">Show email address in store</span></Checkbox>
            </Form.Item>
        </>
    );
}
